import { useAuthStore } from '~/domains/auth';
import { storeToRefs } from 'pinia';

interface DomainRedirectReturn {
  handleRedirectToAnotherDomain: (shopUrl: string, token: string) => boolean;
  handleRedirectToApp: (token: string) => boolean;
}

const isShopRedirectDisabled = (): boolean =>
  String(import.meta.env.VITE_DISABLE_SHOP_URL_REDIRECT ?? '') === 'true';

export default function useDomainRedirect(): DomainRedirectReturn {
  const { redirectFromExternalDomain } = storeToRefs(useAuthStore());

  const redirectToAnotherDomain = (path: string): void => {
    window.location.href = path;
  };

  const redirectToAnotherDomainWithToken = (
    domain: string,
    token: string,
  ): void => {
    const path = `${domain}/login-by-token?token=${token}`;

    redirectToAnotherDomain(path);
  };

  const handleRedirectToAnotherDomain = (
    shopUrl: string,
    token: string,
  ): boolean => {
    const currentDomain = window.location.origin;
    const redirectDomain = shopUrl;

    if (isShopRedirectDisabled() || currentDomain === redirectDomain) {
      return false;
    }

    redirectToAnotherDomainWithToken(redirectDomain, token);

    return true;
  };

  const handleRedirectToApp = (token: string): boolean => {
    const appOrigin: unknown = redirectFromExternalDomain.value;

    if (typeof appOrigin !== 'string' || appOrigin === '') {
      return false;
    }

    redirectToAnotherDomain(`${appOrigin}/login-by-token?token=${token}`);

    return true;
  };

  return {
    handleRedirectToApp,
    handleRedirectToAnotherDomain,
  };
}
